'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'styles/WidgetButton.scss';
import Avatar from 'components/base/Avatar';
import personUtils from 'services/people/personUtils';

const propTypes = {
    disable: PropTypes.bool,
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class WidgetButton extends React.Component {

    render() {

        var style = {};
        if (this.props.disable) {
            style = {opacity:0.3};
        }
        
        return (
            <div id={this.props.id} className="widget-button" style={style}>
                <div className={this.props.iconName}></div>
                <div className="label">{this.props.heading}</div>
            </div>
        );
    }
}

WidgetButton.propTypes = propTypes;

export default WidgetButton; 